module.exports = __webpack_public_path__ + "img/pwa-installed-award.a8f6ce06.png";